import React from 'react';

import {
  maxValue,
  minValue,
  required,
  SelectInput,
} from 'react-admin';

import {
  Grid,
} from '@mui/material';

import NumberInput from '../../layout/inputFields/NumberInput';
import InfoPopover from '../../layout/InfoPopover';
import Label from '../../../customFields/Label';

import { timePeriodChoices } from '../../../constants/timePeriods';

const SharedIpEntityCount = () => (
  <Grid size={12}>
    <Grid container gap={1}>
      <Grid size={12}>
        <NumberInput
          fullWidth
          source="ruleParameters.threshold"
          label="Threshold"
          validate={[required(), minValue(0), maxValue(99)]}
          popups={(
            <InfoPopover title="Entity count threshold" content="Triggers when more than this many distinct entities have used the same IP within the lookback period." />
          )}
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Lookback period"
          info="How far back to look for other entities sharing the same IP."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberInput
          source="ruleParameters.lookbackPeriod.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectInput
          source="ruleParameters.lookbackPeriod.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Unit"
          validate={[required()]}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default SharedIpEntityCount;
